import React from "react";
import cls from "classnames";

const RadioGroup = ({ name, values, selected, onChange }) => (
  <div className="o-btn-group">
    {values.map((val) => {
      const isActive = selected === val.value;

      return (
        <label
          key={val.value}
          className={cls("u-mr-small", {
            active: isActive,
          })}
        >
          <input
            type="radio"
            name={name}
            value={val.value}
            onChange={(ev) => onChange(ev.target.value)}
            checked={isActive}
          />{" "}
          {val.name}
        </label>
      );
    })}
  </div>
);

export default RadioGroup;
